export const getTime = (date: DateType): number => {
  const isDate = typeof date === 'object'
  const dateObj = isDate ? date : new Date(date)
  return dateObj.getTime()
}

export default {
  getTime,
}
